import { FC, MouseEvent, useCallback, useState } from "react";

import { PencilFill } from "@hl/base-components/lib/assets/icons.generated";
import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import { formatDateToUserLocale } from "@hl/communities-app/lib/lib/date-utils";
import {
  ActionIcon,
  Box,
  Group,
  Stack,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { Link, useNavigate } from "react-router-dom";

// import { ReactComponent as DuplicateIcon } from "assets/icons/duplicate-fill.svg";
import { ReactComponent as DeleteIcon } from "assets/icons/trash-fill.svg";
import { TOOLS_URL } from "config";
import DeleteModal from "~/features/gates/DeleteModal";

import * as styles from "./styles";

type GateCardProps = {
  id: string;
  name: string;
  created: string;
};

const GateCard: FC<GateCardProps> = ({ id, name, created }) => {
  const navigate = useNavigate();
  const [deleteGateModalOpen, setDeleteGateModalOpen] =
    useState<boolean>(false);

  const editGateUrl = TOOLS_URL.gates.edit.replace(":gateId", id);

  const handleEditGate = useCallback(
    (event: MouseEvent) => {
      event.preventDefault();
      navigate(editGateUrl);
    },
    [editGateUrl]
  );

  return (
    <Box
      key={id}
      // to={TOOLS_URL.gates.edit.replace(":gateId", id)}
    >
      <Box role="listitem" py={24}>
        <Group position="apart">
          <Stack spacing={4} sx={{ flexBasis: 0, flexGrow: 1 }}>
            <Title order={6} weight={500}>
              {name}
            </Title>
            <Text size="sm" color={TEXT_COLOR.SECONDARY}>
              Created on {formatDateToUserLocale(new Date(created).getTime())}
            </Text>
          </Stack>
          <Group spacing={8}>
            <Tooltip label="Edit gate" withArrow>
              <ActionIcon
                size={40}
                onClick={handleEditGate}
                aria-label="edit gate"
              >
                <PencilFill css={styles.iconStyle} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Delete gate" withArrow>
              <Text component={Link} to={"#"}>
                <ActionIcon
                  size={40}
                  onClick={() => setDeleteGateModalOpen(true)}
                  aria-label="delete gate"
                >
                  <DeleteIcon css={styles.iconStyle} />
                </ActionIcon>
              </Text>
            </Tooltip>
          </Group>
        </Group>
      </Box>
      {deleteGateModalOpen && (
        <DeleteModal
          onClose={() => setDeleteGateModalOpen(false)}
          gateId={id}
          open={deleteGateModalOpen}
        />
      )}
    </Box>
  );
};

export default GateCard;
